
import css from 'styled-jsx/css';

export default css.global`/* @styled-jsx=global */

.webinars__wrap {
  display: grid;
  grid-template-columns: [left-gutter] 1fr [content] 12fr [right-gutter] 1fr;
  overflow: hidden;
  padding-bottom: 70px;

  .feature-spotlight {
    grid-column: content;
    margin: 0 auto;
    max-width: $container-max-width;
    grid-template-columns: [content] 1fr;

    &__background {
      padding: 20px 0 40px;
    }

    &__heading span {
      font-size: 44px;
    }

    &__subheading p {
      line-height: 1.4;
    }
  }
}

.webinars__wrap-single {
  overflow: visible;
}

.webinar__learn-more {
  grid-column: content;
  text-align: center;
  padding: 30px 0 0;
}

@media (min-width: 768px) {
  .webinars__wrap {
    .feature-spotlight {
      &__heading span {
        font-size: 60px;
      }

      &__background {
        padding: 60px 0;
      }
    }
  }
}

@media (min-width: 1100px) {
  .webinars__wrap {
    .feature-spotlight {
      &__heading span {
        font-size: 86px;
      }
    }

    .feature-spotlight {
      &__heading span {
        font-size: 86px;
      }
    }
  }
}
`